import {IPagedResult} from '../../types/common/PagedResult';
import {createReducer, PayloadAction} from '@reduxjs/toolkit';
import {SearchRequest} from '../../types/common/SearchRequest';

import {
  defaultInterviewBookedSearchParamsModel,
  defaultProfileReadySearchParamsModel, defaultSendToEmployerSearchParamsModel,
  DashboardOppParamsModel,
} from '../../types/requests/DashboardOppParamsModel';

import {
  SENT_TO_EMPLOYER_DASHBOARD,
  INTERVIEW_BOOKED_DASHBOARD,
  PROFILE_READY_DASHBOARD,
  DASHBOARD_PRESET,
} from './Actions';
import {ScorecardPresetModel} from '../../types/models/ScorecardPresetModel';
import {PersonSearchResultModel} from '../../types/views/PersonSearchResultModel';
import {PersonSearchResultPaged} from '../../types/views/PersonSearchResultPaged';
import {STUDENT} from '../students/Actions';


export interface IDashboardState {
  interviewBookedDashboardSearchParams: DashboardOppParamsModel | undefined,
  interviewBookedDashboardLoading: boolean,
  interviewBookedDashboardError: string | undefined;
  interviewBookedDashboardResults: IPagedResult<PersonSearchResultModel> | undefined;
  profileReadyDashboardSearchParams: DashboardOppParamsModel | undefined,
  profileReadyDashboardLoading: boolean,
  profileReadyDashboardError: string | undefined;
  profileReadyDashboardResults: IPagedResult<PersonSearchResultModel> | undefined;
  sendToEmployerDashboardSearchParams: DashboardOppParamsModel | undefined,
  sendToEmployerDashboardLoading: boolean,
  sendToEmployerDashboardError: string | undefined;
  sendToEmployerDashboardResults: IPagedResult<PersonSearchResultModel> | undefined;
}

const initialState: IDashboardState = {
  interviewBookedDashboardSearchParams: undefined,
  interviewBookedDashboardLoading: false,
  interviewBookedDashboardError: undefined,
  interviewBookedDashboardResults: undefined,
  profileReadyDashboardSearchParams: undefined,
  profileReadyDashboardLoading: false,
  profileReadyDashboardError: undefined,
  profileReadyDashboardResults: undefined,
  sendToEmployerDashboardSearchParams: undefined,
  sendToEmployerDashboardLoading: false,
  sendToEmployerDashboardError: undefined,
  sendToEmployerDashboardResults: undefined,
};

const dashboardReducer = createReducer(initialState, {
  [SENT_TO_EMPLOYER_DASHBOARD.LOAD]: (state, action: PayloadAction<SearchRequest<DashboardOppParamsModel>>) => {
    state.sendToEmployerDashboardSearchParams = action.payload.searchParams;
    state.sendToEmployerDashboardError = undefined;
    state.sendToEmployerDashboardLoading = true;
  },
  [SENT_TO_EMPLOYER_DASHBOARD.REFRESH]: (state, action: PayloadAction<SearchRequest<DashboardOppParamsModel>>) => {
    state.sendToEmployerDashboardSearchParams = action.payload.searchParams;
    state.sendToEmployerDashboardError = undefined;
  },
  [SENT_TO_EMPLOYER_DASHBOARD.ERROR]: (state, action: PayloadAction<string>) => {
    state.sendToEmployerDashboardError = action.payload;
    state.sendToEmployerDashboardLoading = false;
  },
  [SENT_TO_EMPLOYER_DASHBOARD.LOADED]: (state, action: PayloadAction<PersonSearchResultPaged>) => {
    state.sendToEmployerDashboardResults = action.payload;
    state.sendToEmployerDashboardLoading = false;
    state.sendToEmployerDashboardError = undefined;
  },

  [INTERVIEW_BOOKED_DASHBOARD.LOAD]: (state, action: PayloadAction<SearchRequest<DashboardOppParamsModel>>) => {
    state.interviewBookedDashboardSearchParams = action.payload.searchParams;
    state.interviewBookedDashboardError = undefined;
    state.interviewBookedDashboardLoading = true;
  },
  [INTERVIEW_BOOKED_DASHBOARD.REFRESH]: (state, action: PayloadAction<SearchRequest<DashboardOppParamsModel>>) => {
    state.interviewBookedDashboardSearchParams = action.payload.searchParams;
    state.interviewBookedDashboardError = undefined;
  },
  [INTERVIEW_BOOKED_DASHBOARD.ERROR]: (state, action: PayloadAction<string>) => {
    state.interviewBookedDashboardError = action.payload;
    state.interviewBookedDashboardLoading = false;
  },
  [INTERVIEW_BOOKED_DASHBOARD.LOADED]: (state, action: PayloadAction<PersonSearchResultPaged>) => {
    state.interviewBookedDashboardResults = action.payload;
    state.interviewBookedDashboardLoading = false;
    state.interviewBookedDashboardError = undefined;
  },

  [PROFILE_READY_DASHBOARD.LOAD]: (state, action: PayloadAction<SearchRequest<DashboardOppParamsModel>>) => {
    state.profileReadyDashboardSearchParams = action.payload.searchParams;
    state.profileReadyDashboardError = undefined;
    state.profileReadyDashboardLoading = true;
  },
  [PROFILE_READY_DASHBOARD.REFRESH]: (state, action: PayloadAction<SearchRequest<DashboardOppParamsModel>>) => {
    state.profileReadyDashboardSearchParams = action.payload.searchParams;
    state.profileReadyDashboardError = undefined;
  },
  [PROFILE_READY_DASHBOARD.ERROR]: (state, action: PayloadAction<string>) => {
    state.profileReadyDashboardError = action.payload;
    state.profileReadyDashboardLoading = false;
  },
  [PROFILE_READY_DASHBOARD.LOADED]: (state, action: PayloadAction<PersonSearchResultPaged>) => {
    console.log('PROFILE_READY_DASHBOARD.LOADED', action.payload);
    state.profileReadyDashboardResults = action.payload;
    state.profileReadyDashboardLoading = false;
    state.profileReadyDashboardError = undefined;
  },

});

export default dashboardReducer;
